import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

export interface SetNoteViaSummary {
    commitment?: boolean;
    observation?: boolean;
}

export const setNoteViaSummary = createAction<ActionType, SetNoteViaSummary>(
    ActionType.COACHING_DETAIL__TD__SET_NOTE_VIA_SUMMARY,
);
